import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import baseURL from '../Common/Config';
import Axiosfetch from '../Common/Axiosfetch';
import FailureAlert from '../Common/Failure';
import { CallBackAlert, ValidateEventRecord } from '../Common/Validations/validation';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';
import DatePicker from 'react-datepicker';
import moment from 'moment';

const EventRecord = {
    Name: "",
    StartDate: null,
    EndDate: null,
    Image: null,
    Location: "",
    Heading: "",
    Description: "",
    IsDeleted: 0
};

const AddEventRecords = ({ themeColor, hideeventRecord, getEventRecord, edit, eventRecorddetail, allEventRecord }) => {

    const [eventRecordData, setEventRecordData] = useState(EventRecord);

    useEffect(() => {
        if (parseInt(edit) === 1) {
            var data = eventRecorddetail;
            data.StartDate = new Date(eventRecorddetail.StartDate)
            data.EndDate = new Date(eventRecorddetail.EndDate);

            setEventRecordData(data);

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onTextChange = (e) => {
        let value = e.target.value;
        setEventRecordData({ ...eventRecordData, [e.target.name]: value });
    };

    const SaveEventRecordDetails = (eventRecord) => {
        if (ValidateEventRecord(eventRecord, allEventRecord)) {
            var eventRecorddata = {
                Name: eventRecord.Name.trim(),
                Heading: eventRecord.Heading.trim(),
                StartDate: moment.utc(eventRecord.StartDate),
                EndDate: moment.utc(eventRecord.EndDate),
                Image: null,
                Location: eventRecord.Location.trim(),
                Description: IsUndefinedNullOrEmpty(eventRecord.Description) ? null : eventRecord.Description,
                _id: eventRecord._id
            }

            Axiosfetch(baseURL + ((parseInt(edit) === 0) ? "CreateEventDetailsWithAuth" : "EditEventDetails"), "POST",
                eventRecorddata, EventRecordDetailsSuccess, Failure);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const EventRecordDetailsSuccess = (data) => {
        if (data.success) {
            hideeventRecord();
            getEventRecord();
        }

        CallBackAlert(data);
    };

    const onStartDateChange = (date) => {
        setEventRecordData({ ...eventRecordData, "StartDate": date });
    };

    const onEndDateChange = (date) => {
        setEventRecordData({ ...eventRecordData, "EndDate": date });
    };

    return (
        <div id="addProduct" className="modal" style={{ display: "block" }}>
            <div className="modal-content">
                <div className={`modal-header header-style align-center ${themeColor}`}>
                    <h6 style={{ marginLeft: "5px" }}>{parseInt(edit) === 0 ? "Add" : "Edit"} Event</h6>
                    <span className="close" onClick={hideeventRecord}>&times;</span>
                </div>

                <table className="table">
                    <tbody>
                        <tr>
                            <td>
                                <h6>Event Name<span className="mandatoryStar">*</span></h6>
                            </td>
                            <td>
                                <input type="text" name="Name"
                                    className="form-control"
                                    onChange={e => onTextChange(e)}
                                    value={eventRecordData.Name}></input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <h6>Heading<span className="mandatoryStar">*</span></h6>
                            </td>
                            <td>
                                <input type="text" name="Heading"
                                    className="form-control"
                                    onChange={e => onTextChange(e)}
                                    value={eventRecordData.Heading}></input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <h6>Description</h6>
                            </td>
                            <td>
                                <input type="text" name="Description"
                                    className="form-control"
                                    onChange={e => onTextChange(e)}
                                    value={eventRecordData.Description}></input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <h6>Location<span className="mandatoryStar">*</span></h6>
                            </td>
                            <td>
                                <input type="text" name="Location"
                                    className="form-control"
                                    onChange={e => onTextChange(e)}
                                    value={eventRecordData.Location}></input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <h6>Start Date<span className="mandatoryStar">*</span></h6>
                            </td>
                            <td>
                                <DatePicker className="TextInputStyle datepicker"
                                    onChange={onStartDateChange}
                                    selected={eventRecordData.StartDate}
                                    name="StartDate"
                                    showTimeSelect
                                    timeIntervals={15}
                                    timeCaption="time"
                                    dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <h6>End Date<span className="mandatoryStar">*</span></h6>
                            </td>
                            <td>
                                <DatePicker className="TextInputStyle datepicker"
                                    onChange={onEndDateChange}
                                    selected={eventRecordData.EndDate}
                                    name="EndDate"
                                    showTimeSelect
                                    timeIntervals={15}
                                    timeCaption="time"
                                    dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                            </td>
                        </tr>

                        <tr>
                            <td colSpan="2" style={{ textAlign: "right" }}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${themeColor}Focus`} onClick={() => SaveEventRecordDetails(eventRecordData)}>Save</button>
                                        <button type="button" className="btn btn-default" onClick={hideeventRecord}>Close</button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AddEventRecords;